 "use client";

import * as React from "react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";

const Accordion = AccordionPrimitive.Root;

type AccordionItemRef = React.ElementRef<typeof AccordionPrimitive.Item>;
type AccordionItemProps = React.ComponentPropsWithoutRef<
  typeof AccordionPrimitive.Item
>;

const AccordionItem = React.forwardRef<AccordionItemRef, AccordionItemProps>(
  ({ className, ...props }, ref) => (
    <AccordionPrimitive.Item
      ref={ref}
      className={className}
      {...props}
    />
  ),
);
AccordionItem.displayName = "AccordionItem";

type AccordionTriggerRef = React.ElementRef<typeof AccordionPrimitive.Trigger>;
type AccordionTriggerProps = React.ComponentPropsWithoutRef<
  typeof AccordionPrimitive.Trigger
>;

const AccordionTrigger = React.forwardRef<
  AccordionTriggerRef,
  AccordionTriggerProps
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Header className="m-0">
    <AccordionPrimitive.Trigger
      ref={ref}
      className={`flex w-full items-center justify-between py-[clamp(14px,1.8vw,22px)] text-left text-[clamp(14px,1.6vw,20px)] font-medium text-[color:var(--color-black)] focus-visible:outline focus-visible:outline-[2px] focus-visible:outline-offset-[4px] focus-visible:outline-[color:var(--color-black)] motion-reduce:transition-none [&[data-state=open]>span[data-accordion-icon]]:rotate-180 ${className ?? ""}`}
      {...props}
    >
      <span>{children}</span>
      <span
        aria-hidden="true"
        data-accordion-icon
        className="ml-[16px] text-[color:var(--color-red)] transition-transform duration-[260ms] ease-[cubic-bezier(0.2,0.8,0.2,1)] motion-reduce:transition-none"
      >
        ▼
      </span>
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
));
AccordionTrigger.displayName = "AccordionTrigger";

type AccordionContentRef = React.ElementRef<
  typeof AccordionPrimitive.Content
>;
type AccordionContentProps = React.ComponentPropsWithoutRef<
  typeof AccordionPrimitive.Content
>;

const AccordionContent = React.forwardRef<
  AccordionContentRef,
  AccordionContentProps
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Content
    ref={ref}
    className={`overflow-hidden text-[clamp(13px,1.4vw,18px)] leading-[1.5] text-[color:var(--color-black)] data-[state=open]:animate-[accordion-down_260ms_cubic-bezier(0.2,0.8,0.2,1)] data-[state=closed]:animate-[accordion-up_260ms_cubic-bezier(0.2,0.8,0.2,1)] motion-reduce:data-[state=open]:animate-none motion-reduce:data-[state=closed]:animate-none ${className ?? ""}`}
    {...props}
  >
    <div className="pb-[clamp(12px,1.8vw,22px)]">
      {children}
    </div>
  </AccordionPrimitive.Content>
));
AccordionContent.displayName = "AccordionContent";

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };

